import React from 'react';
import { Script } from 'gatsby';

const VectorPixel = () => {
  if (!process.env.GATSBY_VECTOR_PIXEL_ID) {
    return null;
  }

  return (
    <>
      <Script
        id="vectorPixelId"
        dangerouslySetInnerHTML={{
          __html: `window.vectorPixelId = "${process.env.GATSBY_VECTOR_PIXEL_ID}";`,
        }}
      />
      <Script async src="https://cdn.vector.co/pixel.js" />
    </>
  );
};

export default VectorPixel;
